/**
 * Normalizes a string for case-insensitive comparison (e.g. team names, parallel names).
 * Use when comparing "BASE" vs "Base" vs "base" or "Dodgers" vs "dodgers".
 * @param {string} str - Value to normalize (string or value that will be stringified)
 * @returns {string} Trimmed, uppercase string (empty string if null/undefined)
 */
export const normalizeForCompare = (str) => {
  if (str == null) return '';
  return String(str).trim().toUpperCase();
};

/**
 * Normalizes text for diacritic-insensitive and punctuation-insensitive search comparisons
 * @param {string} text - The text to normalize
 * @returns {string} - Normalized text with diacritics and punctuation removed, converted to lowercase
 */
export const normalizeText = (text) => {
  if (!text || typeof text !== 'string') return '';
  
  return text
    .normalize('NFD') // Decompose characters with diacritics
    .replace(/[\u0300-\u036f]/g, '') // Remove diacritic marks
    .replace(/[^\w\s]/g, '') // Remove all punctuation and special characters (keep letters, numbers, spaces)
    .toLowerCase(); // Convert to lowercase
};

/**
 * Checks if search text matches target text with diacritic-insensitive comparison
 * @param {string} searchText - The search input text
 * @param {string} targetText - The text to search within
 * @returns {boolean} - True if search text is found in target text
 */
export const matchesSearchText = (searchText, targetText) => {
  if (!searchText || !targetText) return false;
  
  const normalizedSearch = normalizeText(searchText);
  const normalizedTarget = normalizeText(targetText);
  
  return normalizedTarget.includes(normalizedSearch);
}; 